import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DocumentListWorkspace } from '@/components/DocumentListWorkspace';
import { useI18n } from '@/lib/i18n';
import { type InvoiceListSearch, InvoiceListSearchSchema } from '@/lib/invoice-list-search';

export const Route = createFileRoute('/order-confirmations/')({
  validateSearch: (search) => InvoiceListSearchSchema.parse(search),
  component: OrderConfirmationsPage,
});

function OrderConfirmationsPage() {
  const { t } = useI18n();
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  return (
    <DocumentListWorkspace
      documentType="order_confirmation"
      search={search}
      copy={{
        sectionLabel: t('orderConfirmations.sectionLabel'),
        pageTitle: t('orderConfirmations.pageTitle'),
        pageDescription: t('orderConfirmations.pageDescription'),
        uploadButton: t('orderConfirmations.newConfirmation'),
        uploadButtonAria: t('orderConfirmations.newConfirmationAria'),
        loadingTitle: t('orderConfirmations.loadingTitle'),
        count: (count) => t('orderConfirmations.count', { count }),
        loadError: t('orderConfirmations.loadError'),
        errorTitle: t('orderConfirmations.errorTitle'),
        retry: t('invoiceList.retry'),
        table: {
          columnNumber: t('orderConfirmationsTable.columnNumber'),
          columnIssueDate: t('orderConfirmationsTable.columnIssueDate'),
          emptyTitle: t('orderConfirmationsTable.emptyTitle'),
          emptyDescription: t('orderConfirmationsTable.emptyDescription'),
          selectAllAria: t('orderConfirmationsTable.selectAllAria'),
          selectItemAria: (confirmation) =>
            t('orderConfirmationsTable.selectConfirmationAria', { confirmation }),
          selectionCount: (count) => t('orderConfirmationsTable.selectionCount', { count }),
          bulkDeleteTitle: t('orderConfirmationsTable.bulkDeleteTitle'),
          bulkDeleteDescription: (count) =>
            t('orderConfirmationsTable.bulkDeleteDescription', { count }),
        },
      }}
      onSearchChange={(next) => {
        void navigate({
          search: (prev) => ({ ...(prev as InvoiceListSearch), ...next }),
          replace: false,
        });
      }}
      onOpenDetail={(id) => {
        void navigate({ to: '/invoices/$id', params: { id } });
      }}
    />
  );
}
